import httpClient from '../http/http-client'
import type { IProjectReportSetting } from './project-report-setting.model'

export default class ProjectReportSettingService {
  http

  constructor() {
    this.http = httpClient
  }

  async getSettings(projectId: string): Promise<IProjectReportSetting> {
    return this.http.get(`project-report/${projectId}/settings`)
      .then(response => response.data)
      .catch(err => { throw err })
  }

  async updateSettings(projectId: string, settings: Partial<IProjectReportSetting>): Promise<IProjectReportSetting> {
    return this.http.patch(`project-report/${projectId}/settings`, settings)
      .then(response => response.data)
      .catch(err => { throw err })
  }

  async saveCoverImage(projectId: string, form: FormData): Promise<IProjectReportSetting> {
    return this.http.post(`project-report/${projectId}/cover-image`, form)
      .then(response => response.data)
      .catch(err => { throw err })
  }
}
